
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/posts/[id]",
      function () {
        return require("private-next-pages/blog/posts/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/posts/[id]"])
      });
    }
  